import React from 'react';

export default function Footer() {
  return <div className="copyright">&copy; Tara Wilson</div>;
}
